export default "__VITE_ASSET__CB4o$Lj0__"